import React from 'react';
import ListStyleTwo from '../../../components/list-style/two';
import MoviikAttractif from '../../../components/svgs/moviikattractif';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    textAlign: 'center',
  },
  header: {
    flexFlow: 'column',
    alignItems: 'center',
    '& h2': {
      marginBottom: 10
    },
    '& > a svg': {
      width: 400,
      height: 'auto',
      marginBottom: 15
    },
    [theme.breakpoints.down('sm')]: {
      '& > a svg': {
        width: '300px!important',
      }
    },
  },
  list: {
    justifyContent: 'center',
    marginTop: 30,
    '& h4': {
      margin: '10px 0'
    }
  },
}));

const Features = (props) => {

  const renderFeatures = () => {
    return props.features.map((feature, index) => {
      return (
        <ListStyleTwo items={feature} key={index} lg={3} />
      );
    });
  };

  const classes = useStyles();
  return (
    <section className={classes.wrapper}>
      <Container id='qm-features-section'>
        <Grid container className={classes.header}>
          <a aria-label="Moviik" href='https://www.moviik.com/' target='_blank' rel='noreferrer'><MoviikAttractif /></a>
          <h3>{props.lang === 'en-CA' ? 'Attractif simplifies digital signage' : 'La solution de gestion d’accueil vous offre:'}</h3>
        </Grid >
        <Grid className={classes.list} container spacing={5}>
          {renderFeatures()}
        </Grid>
      </Container>
    </section>
  );
}

export default Features;